<template>
  <div class="visit-container">
    <div class="w-75rem m-auto">
      <div class="mt-20">
        <myBreadCrumb :list="menuList" />
      </div>
      <!-- 顶部标题 -->
      <div class="w-100 ml-5 h-20rem bgc-w mt-20 flex-row flex-ac bdr-4 b-shadow">
        <el-image class="h-90 w-30rem ml-20 bdr-4" :src="visit.visitPic" fit="cover"></el-image>
        <div class="h-90 ml-20  flex-col font-wl flex-1 text-left">
          <div class="color-p font-1_5rem ">{{ visit.visitName }}</div>
          <div class="color-gray2 font-0_8rem mt-10">地址：{{ visit.visitLocation }}</div>
          <div class="color-gray2 font-0_8rem mt-10 pr-30 t-hd-four flex-1">简介：<span>{{ visit.intro }}</span></div>
          <div class="flex-row flex-je mr-30">
            <div class="mt-20  flex flex-jc flex-ac" v-if="visit.visitType == 1">
              <el-button :type="isEnrolled ? 'success' : 'primary'" :plain="isEnrolled" :disabled="isEnrolled" round
                @click="signvisit">{{ isEnrolled ? ' 报名成功 ' : '我要报名' }}</el-button>
              <span class="ml-10 font-1_3rem color-gray">已报名 {{ total }}人</span>
            </div>
            <div class="mt-20 ml-20 flex flex-jc flex-ac ">
              <el-button icon="el-icon-view" circle type="primary" plain> </el-button>
              <span class="ml-10 font-1_3rem color-gray">{{ visit.readNum }}</span>
            </div>
            <div class="mt-20 ml-20 flex flex-jc flex-ac">
              <el-button icon="el-icon-thumb" circle type="primary" plain @click="like"> </el-button>
              <span class="ml-10 font-1_3rem color-gray">{{ visit.likeNum }}</span>
            </div>
            <div class="mt-20 ml-20">
              <el-button icon="el-icon-share" circle type="primary" plain @click="sharePage(visit)"></el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 下面 -->
      <div class="flex-jsb w-100 flex-1  mt-30 flex-row pb-50">
        <div class="w-65  ph-10 bgc-w mh-50h ">
          <mySection title="场馆介绍" />
          <div class="content">
            <div v-if="visit.content" v-html="visit.content"></div>
            <el-empty v-else description="暂无介绍"></el-empty>
          </div>
          <mySection title="旅行攻略" />
          <div class="content">
            <div class="p-20" v-if="visitList.length">
              <el-steps direction="vertical" :active="visitList.length">
                <el-step :title="item.name" :description="item.details" v-for="(item, index) in visitList"
                  :key="index"></el-step>
              </el-steps>
            </div>
            <el-empty v-else description="暂无具体介绍"></el-empty>
          </div>
        </div>
        <div class="w-30 bgc-w ph-10 h-100">
          <mySection title="推荐攻略" />
          <div class="">
            <div v-if="pushList.length">
              <div v-for="(item, index) in pushList" :key="index">
              <myCommonBox :name="item.visitName" :url="item.visitPic" @onClick = "goPlan(item)" />
            </div>
          </div>
            <el-empty v-else description="暂无推荐"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  myRadio,
  myBreadCrumb,
  mySection,
  myCommonBox,
} from "@/components/index.js";
import share from "@/util/share";
import commmonApi from '../../api/request/common';
import visitApi from "@/api/request/visit.js"
export default {
  name: "visitDetails",
  components: { myRadio, myBreadCrumb, mySection,myCommonBox },
  data() {
    return {
      visitId: '',
      visitList: [],
      likeTimes: 0,
      pushList:[],
      isEnrolled: false,
      total: 0,//总报名人数
      visit: {},
      // 顶部的目录
      menuList: [
        {
          path: "",
          name: "魅力景区",
        }, {
          path: "/visitPlan",
          name: "旅行攻略",
        }, {
          path: "/visitPlanDetails",
          name: "攻略详情",
        },
      ],
    };
  },
  mounted() {
    this.getPush()

    let query = this.$route.query;
    if (query && query.id) {
      this.getvisitInfoById(query.id);
      this.visitId = query.id
      // this.getLikeData();
    }
  },
  methods: {
    goPlan(e) {
      this.getvisitInfoById(e.id);
      this.visitId = e.id
      this.$router.push({
        path: "/visitPlanDetails",
        query: {
          id: e.id
        }
      })
    },
    // 用户点击喜欢
    like() {
      commmonApi.likeRecord({
        partName: '旅行攻略',
        partId: this.visitId,
        isLike: '1',
      }).then(res => {
        if (res.success) {
          visitApi.updateScenicVisit({
            likeNum: this.visit.likeNum + 1,
            id: this.visit.id
          }).then(res2 => {
            if (res2.success) {
              this.$message.success("点赞成功")
              this.visit.likeNum = this.visit.likeNum + 1;
            }
          })
        } else {
          this.$message(res.msg)
        }
      })
    },
    sharePage(e) {
      share.share2QQ(
        {
          url: 'http://yuyitang.xyz:3333',
          desc: e.visitContext,
          title: e.visitName,
        }
      )
    },
    // 获取推介列表
    getPush() {
      visitApi.getScenicVisitList({
        push: 1,
        pageNo: 1,
        pageSize: 5,
      }).then(res => {
        this.pushList = res.data.list
      })
    },
    getvisitInfoById(id) {
      visitApi.queryVisitDetailsById({
        id: id
      }).then(res => {
        if (res.success) {
          console.log({ ...res.data })
          this.visit = res.data[1][0];
          this.visitList = res.data[0]
        }
      })
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../theme/myStyle.less"; //全局样式

.visit-container {
  flex: 1;
}

.content {

  min-height: 20rem;
  overflow-y: scroll;
  max-height: 25rem;
  padding: 0 20px;
}

/deep/ .el-pagination.is-background .el-pager li {
  background: #fff;
}

/deep/ .btn-next,
/deep/ .btn-prev {
  background: #fff !important;
}
</style>